<template>
  <div>
    <div>
      <strong>Color: </strong>
      <span class="text-normal">{{ label }}</span>
    </div>

    <div style="margin-top: 0.35em;">
      <strong v-text="selected.uom == 'EACH' ? 'Price:' : 'Package Price:'"></strong>
      <span class="text-normal">
        {{ price }}
        <small class="text-muted" v-if="selected.uom != 'EACH'">/pkg</small>
      </span>
    </div>

    <div class="variation-wrapper">
      <div
        v-for="(item, i) in items"
        :key="`variation-${i}`"
        @click="update(item)"
        @mouseover="hovered = i"
        @mouseout="hovered = -1"
      >
        <slot
          name="item"
          :disabled="itemIsDisabled(item)"
          :item="item"
          :selected="selected === item"
        >
          <VariationSelectorItem
            :disabled="itemIsDisabled(item)"
            :index="i"
            :item="item"
            :selected="selected === item"
          />
        </slot>
      </div>
    </div>

    <div class="relative">
      <div
        v-if="disabled"
        class="w-full text-smaller text-red"
        style="margin-top: .25em; position: absolute; top: 0; left: 0;"
      >
        <em v-html="disabled"></em>
      </div>
    </div>
  </div>
</template>

<script>
import VariationSelectorItem from './VariationSelectorItem';

import { formattedPrice } from '../helpers.js';

export default {
  components: {
    VariationSelectorItem,
  },

  props: {
    backorderDays: {
      default: 10,
      type: Number,
    },
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      hovered: -1,
      options: [],
    };
  },

  mounted() {
    this.options = this.$children;
  },

  computed: {
    disabled() {
      if(this.hovered < 0 || !this.options || this.options.length === 0) {
        return '&nbsp;';
      }

      if(this.itemIsDisabled(this.items[this.hovered])) {
        return this.options[this.hovered].title
                + ' is '
                + this.options[this.hovered].reason;
      }

      return '&nbsp;';
    },

    label() {
      const title = (this.hovered || {}).title || (this.selected || {}).title;

      return title || '--';
    },

    price() {
      const price = (this.hovered || {}).price || (this.selected || {}).actualPrice;

      return price ? formattedPrice(price) : '--';
    },
  },

  methods: {
    itemIsDisabled(item) {
      const expected = new Date(item.expectedDate).getTime();
      const future = new Date().getTime() + (this.backorderDays * 24 * 60 * 60 * 1000);

      if(
        item.comingsoon === 1
        || (
          item.quantity < 1
          && (!item.expectedDate || expected >= future)
        )
      ) {
        return true;
      }

      return false;
    },

    formattedPrice,

    update(item) {
      if(!this.itemIsDisabled(item)) {
        this.$emit('update:selected', item);
      }
    }
  },
}
</script>

<style scoped>
.variation-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;
  margin-top: .5em;
}
</style>
